module.exports = __webpack_public_path__ + "static/media/shells_minecraft_bg.591f4d59.png";